import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as yup from 'yup';
import { getText, TEXT_KEY } from '../../utils/localization';
import Utils from '../../utils/platform';
export var LOGIN_FIELDS = {
  EMAIL: 'email',
  PASSWORD: 'password'
};
export var initialValues = _defineProperty(_defineProperty({}, LOGIN_FIELDS.EMAIL, ''), LOGIN_FIELDS.PASSWORD, '');
var isWeb = Utils.isWebOrMobileWeb();
export var validationSchema = yup.object({
  email: yup.string().email(isWeb ? function () {
    return getText(TEXT_KEY.INVALID_EMAIL_FORMAT);
  } : getText(TEXT_KEY.INVALID_EMAIL_FORMAT)).required(isWeb ? function () {
    return getText(TEXT_KEY.LOGIN_EMAIL_REQUIRED);
  } : getText(TEXT_KEY.LOGIN_EMAIL_REQUIRED)),
  password: yup.string().min(6, isWeb ? function () {
    return getText(TEXT_KEY.PASSWORD_LENGTH);
  } : getText(TEXT_KEY.PASSWORD_LENGTH)).required(isWeb ? function () {
    return getText(TEXT_KEY.LOGIN_PASSWORD_REQUIRED);
  } : getText(TEXT_KEY.LOGIN_PASSWORD_REQUIRED))
});